import React, { useEffect, useRef } from "react";
import gsap from "gsap";
const PreLoader = () => {
  const svgPathRef = useRef();
  const textRef = useRef();
  useEffect(() => {
    const paths = svgPathRef.current.querySelectorAll(".svg-path");
    const textPaths = svgPathRef.current.querySelectorAll(".path-text");

    paths.forEach((path) => {
      const length = path.getTotalLength();
      gsap.set(path, {
        strokeDasharray: length,
        strokeDashoffset: length,
        fill: "none",
        strokeOpacity: 1,
      });
    });

    const tl = gsap.timeline({ defaults: { ease: "power2.out" } });

    tl.to(paths, {
      strokeDashoffset: 0,
      duration: 2,
      stagger: 0.15,
    });

    tl.to(
      paths,
      {
        fill: (i, el) => el.getAttribute("data-fill"),
        fillOpacity: 1,
        strokeOpacity: 0,
        duration: 0.8,
      },
      "-=0.5"
    );

    tl.from(
      textPaths,
      {
        opacity: 0,
        scale: 0.85,
        transformOrigin: "50% 50%",
        duration: 0.6,
      },
      "-=0.4"
    );
    tl.to(
      textRef.current,
      {
        transform: "translateX(-120%)",
        duration: 6,
        ease: "power2.out",
      },
      "-=0.4"
    );
  }, []);
  return (
    <div className="w-full h-screen overflow-hidden flex flex-col gap-5 justify-center items-center bg-white">
      <div className="mb-32 flex flex-col gap-2 lg:gap-5 justify-center items-center">
        <div className=" lg:mb-0">
          <svg
            ref={svgPathRef}
            className="w-[300px] lg:w-[574px] h-auto"
            width="574"
            height="140"
            viewBox="0 0 574 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M268.7 7.2C263.1 7.6 259.5 9 256.1 13.7C254.1 8.9 251.3 4.9 246.3 3C249.1 3.4 252 3.8 254.5 5.4C255.4 6 256.2 6.8 257.1 7.5C257.4 7.7 257.9 7.9 258.2 7.7C261.6 5.9 265 6.3 268.7 7.2Z"
              fill="url(#paint0_linear_1_2)"
              className="svg-path"
              stroke="url(#paint0_linear_1_2)"
              strokeWidth="2"
            />
            <path
              d="M304 64.3C293.3 62.2 282.5 67 277 76.6C271.7 85.6 272.7 96.2 277.3 103C274.5 89.7 281.7 78.4 291.4 73.7C301.5 68.8 315.8 70.9 323.9 82.5C321.9 74.8 315 66.5 304 64.3Z"
              fill="url(#paint1_linear_1_2)"
              className="svg-path"
              stroke="url(#paint0_linear_1_2)"
              strokeWidth="2"
            />
            <path
              d="M212.5 64.3C201.8 62.2 191 67 185.5 76.6C180.2 85.6 181.2 96.2 185.8 103C183 89.7 190.2 78.4 199.9 73.7C210 68.8 224.3 70.9 232.4 82.5C230.4 74.8 223.5 66.5 212.5 64.3Z"
              fill="url(#paint2_linear_1_2)"
              className="svg-path"
              stroke="url(#paint0_linear_1_2)"
              strokeWidth="2"
            />
            <path
              d="M335.3 70.9C332 64.5 328.3 60.7 325.9 58.8C323.5 57 321.2 55.3 318.9 53.7C305.7 44.1 292.6 34.5 279.4 24.9C278.1 23.8 276.9 23.1 275.8 22.7C275.7 22.6 275.6 22.6 275.5 22.5C271.3 21 268.5 23.4 268.5 23.4L245.5 40.1C243.3 41.7 241.1 43.3 239 44.9C236.9 46.4 234.9 48 232.9 49.6C232.9 49.5 232.8 49.5 232.8 49.4C238.7 44 244.6 38.5 250.6 33C246.8 30 243 27.2 239.3 24.3C235.4 21.3 232.2 21.2 228.2 24.1C216.7 32.5 205.3 40.9 193.8 49.2C190.4 51.7 186.9 54.2 183.5 56.8C183.4 56.9 183.3 57 183.2 57C181.7 58.1 175.5 63.1 171.3 71.3C165.3 83.9 165.4 96.6 171.9 109.3C174.6 114.5 178.4 118.9 183.1 122.4C192.4 129.4 202.9 132.2 214.4 130.4C226.6 128.6 236.1 122.3 242.9 112C244 110.3 245.4 108.8 247 107.5C252.5 103.2 259.1 104.5 263.4 110.7C266.8 115.6 270.5 120.1 275.4 123.5C284.8 129.9 295.2 132.3 306.3 130.1C321.4 127.2 332 118.4 337.5 104C341.6 92.8 340.7 81.6 335.3 70.9ZM208.2 122C199.5 122 192.1 119 185.7 113C182 109.5 179.6 105.2 177.3 100.8C175.5 92.9 174.9 85.1 178.2 77.4C179.9 73.5 182.2 69.9 185.3 66.9C188.5 63.7 192.2 61.3 196.4 59.7C200.1 58.3 204 57.6 208 57.6C225.8 57.7 240.2 72.1 240.2 89.7C240.1 107.5 225.7 122.1 208.2 122ZM298.6 122C280.9 122.1 266.5 107.6 266.4 89.7C266.4 72 280.8 57.6 298.5 57.5C316.3 57.5 330.7 71.9 330.7 89.7C330.8 107.6 316.5 122 298.6 122Z"
              fill="url(#paint3_linear_1_2)"
              className="svg-path"
              stroke="url(#paint0_linear_1_2)"
              strokeWidth="2"
            />
            <path
              d="M37.6 119.4H2V60C2 28.2 27 24.1 39.3 24.1C70.2 24.1 84.5 42.7 84.5 72.6C84.5 104.1 67.2 119.4 37.6 119.4ZM40.3 45.5C33.4 45.5 25.5 49.6 25.5 61.5V98H34.1C49.8 98 59.9 92.1 59.9 72.5C59.9 53.3 54 45.5 40.3 45.5ZM138.4 119.4V83.5C138.4 71.7 136.7 67 128.6 67C121.5 67 115.9 72.4 115.9 84.8V119.4H94.4V25.6H115.9V62.8H116.7C118.9 56 124.4 47.6 137.9 47.6C154.1 47.6 159.9 57.3 159.9 74.8V119.3H138.4V119.4ZM374 68.6C368.8 68.6 366.1 70.6 366.1 76.5V119.5H344.6V72.8C344.6 55.8 353.5 49.2 368.2 49.2H381.6V68.6H374ZM423.2 121C398.1 121 388.6 107.9 388.6 84.2V25.6H410.1V62.5H410.9C413.1 56.5 418.8 47.6 432.9 47.6C449 47.6 458.3 59.3 458.3 83.7C458.3 108.1 443.8 121 423.2 121ZM423.6 67C415.5 67 410.1 73.3 410.1 84.2C410.1 96.8 415.1 101.6 423.3 101.6C431.6 101.6 436.9 96.1 436.9 84.3C437 72 432.4 67 423.6 67ZM469.1 34.9C469.1 29.8 473.3 25.6 478.4 25.6H481.3C486.4 25.6 490.6 29.8 490.6 34.9C490.6 40 486.4 44.2 481.3 44.2H478.4C473.2 44.2 469.1 40.1 469.1 34.9ZM469.1 119.4V49.2H490.6V119.4H469.1ZM569.1 119.4H547.6V80.4C547.6 71.6 545.4 67 536.5 67C528.4 67 525.1 71.3 525.1 80.4V119.4H503.6V80.4C503.6 57.6 516.2 47.7 536.6 47.7C558.5 47.7 569.1 59.5 569.1 80.4V119.4Z"
              fill="url(#paint4_linear_1_2)"
              className="path-text"
            />

            <defs>
              <linearGradient
                id="paint0_linear_1_2"
                x1="246.326"
                y1="8.3263"
                x2="268.746"
                y2="8.3263"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#2E3192" />
                <stop offset="1" stopColor="#00AEEF" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_1_2"
                x1="298.57"
                y1="28.904"
                x2="298.57"
                y2="151.976"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#2E3192" />
                <stop offset="1" stopColor="#00AEEF" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_1_2"
                x1="207.075"
                y1="28.904"
                x2="207.075"
                y2="151.976"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#2E3192" />
                <stop offset="1" stopColor="#00AEEF" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_1_2"
                x1="253.339"
                y1="-20.6338"
                x2="253.339"
                y2="164.092"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#2E3192" />
                <stop offset="1" stopColor="#00AEEF" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_1_2"
                x1="282.313"
                y1="-10.5334"
                x2="286.634"
                y2="136.382"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0E1D60" />
                <stop offset="1" stopColor="#00AEEF" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_1_2"
                x1="345.189"
                y1="131.503"
                x2="570.1"
                y2="131.503"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#00AEEF" />
                <stop offset="1" stopColor="#0E1D60" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div>
          <h1
            ref={textRef}
            className="text-2xl lg:text-7xl font-bold text-black/20 text-nowrap translate-x-[100%] lg:translate-x-[120%]"
          >
            YOUR WORLD OF TRAVEL JUST ONE CLICK AWAY
          </h1>
        </div>
      </div>
    </div>
  );
};

export default PreLoader;
